import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RedirectLoginResult } from '@auth0/auth0-spa-js';
import {
  AppStateService,
  IUserProfile,
  SessionService,
  StorageService,
} from '@services';
import { Logger } from '@utils/logger';

const logger = Logger.getLogger('Auth0LogoutCallbackComponent');

@Component({
  selector: 'ft-auth0-logout-callback',
  templateUrl: './auth0-logout-callback.component.html',
  styleUrls: ['./auth0-logout-callback.component.scss'],
})
export class Auth0LogoutCallbackComponent implements OnInit {
  constructor(
    private router: Router,
    private sessionService: SessionService,
    private storageService: StorageService,
    private appStateService: AppStateService
  ) {}

  ngOnInit(): void {
    // TODO handle connection error
    this.storageService
      .getAuth0CallbackRoute()
      ?.then((route) => {
        if (route) {
          this.router.navigate([route]);
        } else {
          this.router.navigate([this.appStateService.getHomePageUrl]);
        }
      })
      .catch(() => {
        this.router.navigate([this.appStateService.getHomePageUrl]);
      });
  }
}
